import initState from "./state";
import * as analyticsActions from "./analytics/actions";
import * as analyticsActionHandlers from "./analytics/action-handlers";
import * as chartFiltersActions from "./chart-filters/actions";
import * as chartFiltersActionHandlers from "./chart-filters/action-handlers";
import * as chartHeaderActions from "./chart-header/actions";
import * as chartHeaderActionHandlers from "./chart-header/action-handlers";
import * as chartTypeIconsActions from "./chart-type-icons/actions";
import * as chartTypeIconsActionHandlers from "./chart-type-icons/action-handlers";
import * as chartGranularityActions from "./chart-granularity/actions";
import * as chartGranularityActionHandlers from "./chart-granularity/action-handlers";
import * as chartCostToTradeLotSizesActions from "./chart-cost-to-trade-lot-sizes/actions";
import * as chartCostToTradeLotSizesActionHandlers from "./chart-cost-to-trade-lot-sizes/action-handlers";
import * as chartDownloadActions from "./chart-download/actions";
import * as chartDownloadActionHandlers from "./chart-download/action-handlers";
import * as chartFooterActions from "./chart-footer/actions";
import * as chartFooterActionHandlers from "./chart-footer/action-handlers";

const reducer = (state = initState, action) => {
  switch (action.type) {
    // Analytics Component

    case analyticsActions.ON_APP_LOAD:
      return analyticsActionHandlers.onAppLoad(state, action);

    // Chart Filters Component

    case chartFiltersActions.ON_SELECTED_PRODUCT_CHANGE:
      return chartFiltersActionHandlers.onSelectedProductChangeHandler(state, action);

    case chartFiltersActions.ON_SELECTED_DATE_RANGE_CHANGE:
      return chartFiltersActionHandlers.onSelectedDateRangeChangeHandler(state, action);

    case chartFiltersActions.ON_SELECTED_ZONE_CHANGE:
      return chartFiltersActionHandlers.onSelectedZoneChangeHandler(state, action);

    // Chart Header Component

    case chartHeaderActions.ON_SELECTED_PRIMARY_CHART_CHANGE:
      return chartHeaderActionHandlers.onSelectedPrimaryChartChange(state, action);

    case chartHeaderActions.ON_SELECTED_COMPARISON_CHART_CHANGE:
      return chartHeaderActionHandlers.onSelectedComparisonChartChange(state, action);

    case chartHeaderActions.ON_SELECTED_CHART_LAYER_CHANGE:
      return chartHeaderActionHandlers.onSelectedChartLayerChange(state, action);

    case chartHeaderActions.ON_VIEW_CHART_CLICK:
      return chartHeaderActionHandlers.onViewChartClick(state, action);

    // Chart Type Icons Component

    case chartTypeIconsActions.ON_SELECTED_CHART_TYPE_CHANGE:
      return chartTypeIconsActionHandlers.onSelectedChartTypeChange(state, action);

    // Chart Granularity Component

    case chartGranularityActions.ON_SELECTED_GRANULARITY_CHANGE:
      return chartGranularityActionHandlers.onSelectedGranularityChange(state, action);

    // Chart Cost To Trade Lot Sizes Component

    case chartCostToTradeLotSizesActions.ON_SELECTED_COST_TO_TRADE_LOT_SIZES_CHANGE:
      return chartCostToTradeLotSizesActionHandlers.onSelectedCostToTradeLotSizesChange(state, action);

    // Chart Download Component

    case chartDownloadActions.ON_DOWNLOAD_CLICK:
      return chartDownloadActionHandlers.onDownloadClick(state, action);

    // Chart Footer Component

    case chartFooterActions.ON_ADD_NEW_WHITEBOARD_CLICK:
      return chartFooterActionHandlers.onAddNewWhiteboardClick(state, action);

    case chartFooterActions.ON_REMOVE_WHITEBOARD_CLICK:
      return chartFooterActionHandlers.onRemoveWhiteboardClick(state, action);

    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/store/analytics/reducer.js